// src/components/union-settings/banks/UnionDiscardChangesDialog.tsx
import { Button, Dialog, Portal } from '@chakra-ui/react'

export default function UnionDiscardChangesDialog({
  open,
  onOpenChange,
  onDiscard,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  onDiscard: () => void
}) {
  return (
    <Dialog.Root open={open} onOpenChange={e => onOpenChange(e.open)} size="xs">
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content rounded="l3" shadow="0px 8px 16px 0px gray.900;">
            <Dialog.Header>
              <Dialog.Title fontSize="lg" fontWeight="600">
                Anlage der Bank abbrechen
              </Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>

            <Dialog.Body color="fg.muted" fontSize="sm" mt={-3}>
              Wenn Sie den Vorgang abbrechen, werden alle bisher eingegebenen Daten verworfen.
              Möchten Sie die Anlage der Bank abbrechen?
            </Dialog.Body>

            <Dialog.Footer gap={3} mt={-4}>
              <Button variant="outline" size="md" onClick={() => onOpenChange(false)}>
                Zurück zur Bearbeitung
              </Button>

              <Button size="md" bg="red.solid" _hover={{ opacity: 0.85 }} onClick={onDiscard}>
                Verwerfen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
